import { Smartphone, Apple, Play } from 'lucide-react';

export const DERSJET_IOS_URL = 'https://apps.apple.com/us/app/ba%C4%9Flama-akort-ve-metronom/id1520458900';
export const DERSJET_ANDROID_URL = 'https://play.google.com/store/apps/details?id=org.umitates.baglamatuner';

export const StoreBadges = ({ size = 'md' }) => {
  const pad = size === 'sm' ? 'px-3 py-1.5' : 'px-5 py-2.5';
  const icon = size === 'sm' ? 'w-4 h-4' : 'w-6 h-6';
  return (
    <div className="flex flex-wrap items-center gap-3">
      <a
        href={DERSJET_IOS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={`flex items-center gap-2.5 ${pad} rounded-xl bg-white text-black hover:bg-white/90 transition-colors`}
        data-testid="app-store-badge"
      >
        <Apple className={icon} />
        <span className="text-left leading-tight">
          <span className="block text-[10px] opacity-70">İndir</span>
          <span className={`block font-semibold ${size === 'sm' ? 'text-xs' : 'text-sm'}`}>App Store</span>
        </span>
      </a>
      <a
        href={DERSJET_ANDROID_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={`flex items-center gap-2.5 ${pad} rounded-xl bg-white/10 border border-white/20 text-white hover:bg-white/20 transition-colors`}
        data-testid="google-play-badge"
      >
        <Play className={icon} />
        <span className="text-left leading-tight">
          <span className="block text-[10px] opacity-70">İndir</span>
          <span className={`block font-semibold ${size === 'sm' ? 'text-xs' : 'text-sm'}`}>Google Play</span>
        </span>
      </a>
    </div>
  );
};

export const AppDownloadSection = () => {
  return (
    <section className="py-20 relative overflow-hidden" data-testid="app-download-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="glass rounded-3xl border border-primary/30 p-8 md:p-12 relative overflow-hidden">
          <div className="absolute -right-20 -top-20 w-64 h-64 rounded-full bg-primary/15 blur-3xl" />
          <div className="grid md:grid-cols-2 gap-10 items-center relative z-10">
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/20 text-primary text-sm mb-4">
                <Smartphone className="w-4 h-4" />
                Mobil Uygulama
              </div>
              <h2 className="font-heading text-2xl md:text-4xl font-bold mb-4">
                DersJet ile Bağlama Eğitimi <span className="gradient-text">Cebinizde</span>
              </h2>
              <p className="text-muted-foreground mb-6">
                Bağlama dersleri, akort cihazı ve metronom tek uygulamada.
                DersJet uygulamasını iOS veya Android cihazınıza ücretsiz indirin,
                derslerinize dilediğiniz yerden devam edin.
              </p>
              <ul className="space-y-2 text-sm text-muted-foreground mb-8">
                <li className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-primary" />Bağlama, cura, gitar, keman ve daha fazlası</li>
                <li className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-primary" />Mikrofonla çalışan hassas akort cihazı</li>
                <li className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-primary" />Profesyonel metronom ve ders takibi</li>
              </ul>
              <StoreBadges />
            </div>
            <div className="hidden md:flex justify-center">
              <div className="relative w-56 h-[420px] rounded-[2.5rem] border-4 border-white/15 bg-gradient-to-b from-[#1a1a1a] to-[#0d0d0d] shadow-2xl flex flex-col items-center justify-center gap-4 p-6">
                <div className="absolute top-3 left-1/2 -translate-x-1/2 w-20 h-1.5 rounded-full bg-white/20" />
                <div className="w-16 h-16 rounded-2xl bg-primary flex items-center justify-center shadow-[0_0_40px_rgba(255,85,0,0.5)]">
                  <Smartphone className="w-8 h-8 text-white" />
                </div>
                <span className="font-heading text-xl font-bold">DersJet</span>
                <span className="text-xs text-muted-foreground text-center">Bağlama Dersleri, Akort & Metronom</span>
                <div className="w-full h-24 rounded-xl bg-primary/10 border border-primary/30 flex items-center justify-center">
                  <span className="text-primary text-3xl font-mono font-bold">La</span>
                </div>
                <div className="flex gap-1.5">
                  {[...Array(5)].map((_, i) => (
                    <div key={i} className={`w-2 h-8 rounded-full ${i === 2 ? 'bg-primary' : 'bg-white/15'}`} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
